import { TargetCheckTypeNew } from '@nkr/enums/target-check-type';

export interface IVoucherScenarioItem {
    type: TargetCheckTypeNew,
    min: number,
    max: number
}